import PureLoadable from 'react-17-pure-loadable';

const MainLayout = PureLoadable({
  loader: () => import('./main/main'),
  displayName: 'MainLayout',
});

export { MainLayout };
